/**
 * Configuración SEO global de Cerámicas Gassull
 * Datos de la empresa para uso en meta tags, Open Graph, Schema.org, etc.
 */

export const SEO_CONFIG = {
  // Información básica de la empresa
  company: {
    name: "Cerámicas Gassull",
    legalName: "Cerámicas Gassull",
    description: "Especialistas en cerámicas y materiales de construcción de alta calidad. Más de 25 años de experiencia en Mendoza, Argentina.",
    foundingDate: "1995",
    url: "https://www.ceramicagassull.com",
  },

  // Información de contacto
  contact: {
    email: "gassullceramica@gmail.com",
    phone: "+54 9 2617 13-5406",
    phoneFormatted: "+5492617135406", // Sin espacios ni guiones para links
    address: {
      street: "A 1 CUADRA DE LA ROTONDA DEL AVION, Lateral Oeste de Costanera Norte y, Bajada de Arrollabes",
      city: "Las Heras",
      region: "Mendoza",
      country: "Argentina",
      postalCode: "M5539",
      full: "A 1 CUADRA DE LA ROTONDA DEL AVION, Lateral Oeste de Costanera Norte y, Bajada de Arrollabes, M5539 Las Heras, Mendoza, Argentina",
    },
    coordinates: {
      latitude: -32.87284410944235,
      longitude: -68.8195651711744,
    },
    businessHours: {
      weekdays: "8:00 - 18:00",
      saturday: "8:00 - 13:00",
      sunday: "Cerrado",
    },
  },

  // Redes sociales (si existen, agregar aquí)
  social: {
    facebook: undefined,
    instagram: undefined,
    twitter: undefined,
    linkedin: undefined,
  },

  // Imágenes
  images: {
    logo: "https://res.cloudinary.com/dq8ig7aly/image/upload/v1749660976/no-image_lbt2of.jpg", // TODO: Reemplazar con logo real
    defaultOgImage: "https://res.cloudinary.com/dq8ig7aly/image/upload/v1749660976/no-image_lbt2of.jpg", // TODO: Crear imagen OG específica
  },

  // Configuración por defecto
  defaults: {
    title: "Cerámicas Gassull - Materiales de Construcción en Mendoza",
    description: "Cerámicas Gassull: Especialistas en cerámicas y materiales de construcción de alta calidad. Más de 25 años de experiencia en Mendoza, Argentina. Amplio catálogo de productos para tu proyecto.",
    keywords: "cerámicas, materiales construcción, Mendoza, Argentina, ladrillos, cemento, viguetas, revestimientos, construcción",
    author: "Cerámicas Gassull",
    locale: "es_AR",
    siteName: "Cerámicas Gassull",
  },
} as const;

/**
 * Generar URL completa con dominio base
 */
export function getFullUrl(path: string = ""): string {
  const baseUrl = SEO_CONFIG.company.url.replace(/\/$/, ""); // Remover trailing slash
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
}

/**
 * Generar título SEO con formato estándar
 * Formato: "Título | Cerámicas Gassull"
 */
export function formatSeoTitle(title: string, includeBrand: boolean = true): string {
  if (!title.trim()) return SEO_CONFIG.defaults.title;
  
  const cleanTitle = title.trim();
  if (!includeBrand || cleanTitle.includes("Cerámicas Gassull")) {
    return cleanTitle.length > 60 ? `${cleanTitle.substring(0, 57)}...` : cleanTitle;
  }
  
  const fullTitle = `${cleanTitle} | Cerámicas Gassull`;
  return fullTitle.length > 60 ? `${fullTitle.substring(0, 57)}...` : fullTitle;
}

